import { render, staticRenderFns } from "./df-page-pdf.vue?vue&type=template&id=1c27b1aa"
import script from "./df-page-pdf.ts?vue&type=script&lang=js&external"
export * from "./df-page-pdf.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports